


















































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { MensagensDaApiEnum } from '@/types/_'
import FeriadoStore from '../Store/FeriadoStore'

@Component

export default class ComponentModalCriarEditarSenioridade extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string
  menu: boolean = false

  $refs!: { formItemFeriado: any }

  formItemFeriadoRules: any = {
    valid: true,
    nome: [(v: string) => !!v || 'Campo obrigatório'],
    data: [(v: string) => !!v || 'Campo obrigatório'],
    tipo: [(v: string) => !!v || 'Campo obrigatório'],
    observacao: [(v: string) => !!v || 'Campo obrigatório'],
  }

  loadCreateOrUpdateItemSenioridade: boolean = false
  get loadingCreateOrUpdateItemFeriado() { return this.loadCreateOrUpdateItemSenioridade }
  set loadingCreateOrUpdateItemFeriado(value: boolean) { this.loadCreateOrUpdateItemSenioridade = value }

  get modalCriarEditarItemFeriado() { return this.feriadoStore.modal.itemFeriado }
  set modalCriarEditarItemFeriado(value: boolean) { this.feriadoStore.setModal({ name: 'itemFeriado', value }) }

  get feriadoStore() {
    return getModule(FeriadoStore, this.$store)
  }

  get tiposFeriadoList() {
    return this.feriadoStore.tiposFeriadoList
  }

  get formattedDate() {
    const date = this.feriadoStore.itemFeriado.data
    return date ? this.formatDateForDisplay(date) : ''
  }

  set formattedDate(value: string) {
    this.feriadoStore.itemFeriado.data = this.formatDateForApi(value)
  }

  formatDateForDisplay(date: string) {
    try {
      const parsedDate = this.parseDate(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      return `${day}/${month}/${year}`
    } catch (error) {
      console.error('Erro ao formatar a data para exibição:', error)
      return ''
    }
  }

  formatDateForApi(date: string) {
    try {
      const [day, month, year] = date.split('-')
      if (!day || !month || !year) throw new Error('Data no formato inválido')

      const formattedDate = new Date(`${year}-${month}-${day}T00:00:00Z`)
      if (formattedDate.toString() === 'Invalid Date') {
        throw new Error('Data inválida')
      }

      return formattedDate.toISOString().split('T')[0]
    } catch (error) {
      console.error('Erro ao formatar a data para a API:', error)
      return ''
    }
  }

  parseDate(date: string) {
    if (date.includes('T')) {
      return new Date(date)
    }
    const [year, month, day] = date.split('-').map(Number)
    return new Date(year, month - 1, day)
  }


  async createOrUpdateItemFeriado() {
    this.loadingCreateOrUpdateItemFeriado = true

    if (this.$refs.formItemFeriado.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.feriadoStore.createItemFeriado()
        : await this.feriadoStore.updateItemFeriado()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarEditarItemFeriado = false
          this.loadingCreateOrUpdateItemFeriado = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item de feriado ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.modalCriarEditarItemFeriado = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdateItemFeriado = false
  }

  @Watch('modalCriarEditarItemFeriado')
  onChangeModalCriarEditarItemFeriado(value) {
    if (!value) {
      this.feriadoStore.clearItemFeriado()
      this.$refs.formItemFeriado.resetValidation()
    }
  }
}
